<template>
  <v-container>
    <v-container class="pa-0" fluid>
      <v-row justify="center" v-if="!feedbackUpdated">
        <v-col cols="12" sm="10">
          <v-row justify="center">
            <div class="pa-3 text-h5 font-weight-bold">
              {{ $t('customer-feedback-header') }}
            </div>
          </v-row>
          <v-row justify="center">
            <v-col cols="12" sm="9">
              <v-row justify="center">
                <div class="px-3 text-center" v-show="smiley === null || smiley === 1" :style="{ cursor: smileyCursor }" @click="chooseSmiley(1)">
                  <v-icon :size="52" :color="smileyColor">
                    far fa-smile
                  </v-icon>
                  <p class="mt-2" v-if="smiley === null">{{ $t('customer-feedback-text-1') }}</p>
                </div>
                <div class="px-3 text-center" v-show="smiley === null || smiley === 0" :style="{ cursor: smileyCursor }" @click="chooseSmiley(0)">
                  <v-icon :size="52" :color="smileyColor">
                    far fa-frown
                  </v-icon>
                  <p class="mt-2" v-if="smiley === null">{{ $t('customer-feedback-text-2') }}</p>
                </div>
              </v-row>
            </v-col>
          </v-row>

          <v-expand-transition>
            <div v-show="feedbackSent">
              <v-row justify="center">
                <div class="px-3 text-h6" v-if="smiley === 1">
                  {{ $t('customer-feedback-text-3') }}
                </div>
                <div class="px-3 text-h6" v-if="smiley === 0">
                  {{ $t('customer-feedback-text-4') }}
                </div>
              </v-row>
              <v-row justify="center">
                <v-col cols="12" sm="9">
                  <v-textarea v-model="comment"
                              outlined
                              auto-grow
                              :counter="300"
                              maxlength="300"
                              :placeholder="$t('customer-feedback-text-5')"
                              @blur="$v.comment.$touch()"
                              @change="$v.comment.$touch()"
                              :error-messages="commentError" />
                </v-col>
              </v-row>
              <v-row justify="center">
                <div class="pa-3 pt-0">
                  <v-btn tile class="primary wide-button" @click="updateFeedback" :disabled="loading || !isValid" :loading="loading">
                    {{ $t('customer-feedback-send') }}
                  </v-btn>
                </div>
              </v-row>
            </div>
          </v-expand-transition>

        </v-col>
      </v-row>
      <v-row v-else justify="center">
        <v-col cols="12" sm="10">
          <v-row justify="center">
            <div class="pa-3">
              <v-icon :size="52" color="color-new-title-green">
                fas fa-check-circle
              </v-icon>
            </div>
          </v-row>
          <v-row justify="center">
            <div class="pa-3 text-h5 font-weight-bold">
              {{ $t('customer-feedback-text-6') }}
            </div>
          </v-row>
        </v-col>
      </v-row>
    </v-container>
  </v-container>
</template>

<script>
  import { apiResource } from '@/util/resources'
  import { required } from 'vuelidate/lib/validators'

  export default {
    props: ['orderNr', 'type'],
    data: function () {
      return {
        smiley: null,
        comment: '',
        feedbackSent: false,
        feedbackUpdated: false,
        feedbackNr: null
      }
    },
    computed: {
      loading() {
        return this.$store.getters.loading
      },
      smileyColor() {
        if (this.smiley === null) {
          return 'color-new-dark-grey'
        } else if (this.smiley === 1) {
          return 'color-new-title-green'
        } else if (this.smiley === 0) {
          return 'red'
        }
      },
      smileyCursor() {
        if (this.smiley !== null) {
          return 'default'
        } else {
          return 'pointer'
        }
      },
      commentError() {
        const errors = []
        if (!this.$v.comment.$dirty) return errors
        !this.$v.comment.required && errors.push(this.$t('commentErrors.required'))
        return errors
      },
      isValid () {
        if (this.comment.length > 0 &&
          (!this.$v.comment.$error && this.$v.comment.$dirty)) {
          return true
        } else {
          return false
        }
      },
    },
    methods: {
      chooseSmiley(value) {
        if (!this.feedbackSent) {
          this.smiley = parseInt(value)
          this.sendFeedback()
        }
      },
      sendFeedback() {
        if (this.feedbackSent === false) {
          this.$store.commit('setLoading', true)

          var data = {
            FeedbackType: this.type,
            OrderNr: this.orderNr,
            Comment: null,
            Smiley: this.smiley,
            NPS: null
          }

          apiResource.post('api/feedback/save', data).then((response) => {
            this.$store.commit('setLoading', false)

            if (response.data.status === 0) {
              if (response.data.responseObject != null && response.data.responseObject > 0) {
                this.feedbackSent = true
                this.feedbackNr = response.data.responseObject
                if (this.type === 2) {
                  this.$matomo && this.$matomo.trackEvent("Feedback", "Payment", "Feedback Sent", this.smiley)
                } else if (this.type === 3) {
                  this.$matomo && this.$matomo.trackEvent("Feedback", "PaymentPlan", "Feedback Sent", this.smiley)
                } else if (this.type === 4) {
                  this.$matomo && this.$matomo.trackEvent("Feedback", "Invoice copy", "Feedback Sent", this.smiley)
                } else if (this.type === 5) {
                  this.$matomo && this.$matomo.trackEvent("Feedback", "Reclamation", "Feedback Sent", this.smiley)
                } else if (this.type === 6) {
                  this.$matomo && this.$matomo.trackEvent("Feedback", "Verdict downloaded", "Feedback Sent", this.smiley)
                } else if (this.type === 7) {
                  this.$matomo && this.$matomo.trackEvent("Feedback", "Reconciliation", "Feedback Sent", this.smiley)
                }
              } else {
                this.$store.commit('setMessage', { type: 'error', text: response.data.errorCode, translate: true })
              }
            } else {
              this.$store.commit('setMessage', { type: 'error', text: response.data.errorCode, translate: true })
            }
          }).catch((errorResponse) => {
            this.$store.commit('setLoading', false)
            this.$store.commit('setMessage', { type: 'error', text: 'error.generic.0', translate: true })
          })
        }
      },
      updateFeedback() {
        this.$store.commit('setLoading', true)

        var data = {
          Nr: this.feedbackNr,
          FeedbackType: this.type,
          OrderNr: this.orderNr,
          Comment: this.comment,
          Smiley: null,
          NPS: null
        }

        if (data.Nr > 0 && this.isValid) {
          apiResource.post('api/feedback/update', data).then((response) => {
            this.$store.commit('setLoading', false)

            if (response.data.status === 0) {
              if (response.data.responseObject != null) {
                this.feedbackUpdated = true
                if (this.type === 2) {
                  this.$matomo && this.$matomo.trackEvent("Feedback", "Payment", "Feedback Updated")
                } else if (this.type === 3) {
                  this.$matomo && this.$matomo.trackEvent("Feedback", "PaymentPlan", "Feedback Updated", this.smiley)
                } else if (this.type === 4) {
                  this.$matomo && this.$matomo.trackEvent("Feedback", "Invoice copy", "Feedback Updated", this.smiley)
                } else if (this.type === 5) {
                  this.$matomo && this.$matomo.trackEvent("Feedback", "Reclamation", "Feedback Updated", this.smiley)
                } else if (this.type === 6) {
                  this.$matomo && this.$matomo.trackEvent("Feedback", "Verdict downloaded", "Feedback Updated", this.smiley)
                } else if (this.type === 7) {
                  this.$matomo && this.$matomo.trackEvent("Feedback", "Reconciliation", "Feedback Updated", this.smiley)
                }
              } else {
                this.$store.commit('setMessage', { type: 'error', text: response.data.errorCode, translate: true })
              }
            } else {
              this.$store.commit('setMessage', { type: 'error', text: response.data.errorCode, translate: true })
            }
          }).catch((errorResponse) => {
            this.$store.commit('setLoading', false)
            this.$store.commit('setMessage', { type: 'error', text: 'error.generic.0', translate: true })
          })
        } else {
          this.$store.commit('setLoading', false)
          this.$store.commit('setMessage', { type: 'error', text: 'error.generic.0', translate: true })
        }
      }
    },
    validations: {
      comment: {
        required
      }
    }
  }
</script>

<i18n>
  {
  "fi": {
  "customer-feedback-header": "Mitä pidit asioimisesta Oma B2 Impact:issa?",
  "customer-feedback-text-1": "Kaikki sujui hyvin",
  "customer-feedback-text-2": "En ollut tyytyväinen",
  "customer-feedback-text-3": "Kiva kuulla! Missä onnistuimme parhaiten?",
  "customer-feedback-text-4": "Harmin paikka! Kuinka voisimme parantaa palveluamme?",
  "customer-feedback-text-5": "Voit kirjoittaa palautteesi tähän. Jos sinulla on kysyttävää, otathan yhteyttä suoraan asiakaspalveluumme.",
  "customer-feedback-text-6": "Kiitos palautteestasi!",
  "customer-feedback-send": "lähetä palaute",
  "commentErrors": {
  "required": "Syötä palaute"
  }
  },
  "se": {
  "customer-feedback-header": "Vad tyckte du om att sköta dina ärenden via Min B2 Impact tjänsten?",
  "customer-feedback-text-1": "Allt gick bra",
  "customer-feedback-text-2": "Jag är missnöjd",
  "customer-feedback-text-3": "Trevligt att höra! Med vad lyckades vi bäst?",
  "customer-feedback-text-4": "Tråkigt att höra! Hur kan vi förbättra våra tjänster?",
  "customer-feedback-text-5": "Du kan ge din respons här. Om du har övriga frågor gällande tjänsten, vänligen kontakta vår kundtjänst.",
  "customer-feedback-text-6": "Tack för din respons!",
  "customer-feedback-send": "Skicka respons",
  "commentErrors": {
  "required": "Fyll i respons"
  }
  },
  "en": {
  "customer-feedback-header": "How was your experience with Min B2 Impact?",
  "customer-feedback-text-1": "All went well",
  "customer-feedback-text-2": "I wasn't happy",
  "customer-feedback-text-3": "Great! What was best about your experience?",
  "customer-feedback-text-4": "That's too bad! How could we improve our service?",
  "customer-feedback-text-5": "You can leave your feedback here. If you have support questions, please contact our customer service directly.",
  "customer-feedback-text-6": "Thank you for your feedback!",
  "customer-feedback-send": "Submit feedback",
  "commentErrors": {
  "required": "Comment is required"
  }
  }
  }
</i18n>

<style>
  .feedback-slider .v-slider__thumb {
    width: 24px;
    height: 24px;
    left: -13px;
  }

    .feedback-slider .v-slider__thumb:before {
      top: -6px;
      left: -6px;
    }

  .feedback-slider .v-slider--horizontal .v-slider__ticks-container {
    color: #A2ADB8;
    font-weight: bold;
  }

  .feedback-slider .v-slider--horizontal .v-slider__track-container {
    height: 6px;
  }

  @media (min-width: 768px) {
    .feedback-slider .v-slider--horizontal .v-slider__ticks-container {
      font-size: 1.25rem;
    }
  }
</style>
